// extracted by mini-css-extract-plugin
export default {"back":"ProfileBack_back__vyts7","arrow":"ProfileBack_arrow__yGWz3"};